<app-loader *ngIf="isLoading"></app-loader>
<div class="trip-container">
  <div class="fs-12 font-weight-700 color-181F33 mb-16 mt-16 ml-24">Bookings being merged</div>
  <div class="pb-24 ml-24 displayFlex">
    <div class="single-card displayFlexColumn mr-12 " *ngFor="let booking of bookings">
      <div class=" card-row displayFlexSpaceBetween ">
        <div class="fs-14 font-weight-700 displayFlex align-item-flex-start " style="width: 240px;" (click)="openDetailsSidebar(booking)">
          {{booking.bookingId}} <span class="ml-8 " *ngIf="booking.guardReq"> <img
              src="assets/MarshallGrey.svg" alt=""></span></div>
        <div class="view-details" (click)="openDetailsSidebar(booking)">View Details</div>
      </div>
    </div>
  </div>
  <div class="marshallToggle mr-12">
   <span class="fs-14 font-weight-700 color-181F33 mr-8"> Marshall needed </span>
    <app-toggle-button [marshallNeeded]="onMarshallToggle" [isDisabled]="disableMarshallToggle" [formControl]="bookingForm.get('guardReq')"></app-toggle-button> 
    <span *ngIf="preRequestedMarshall" class="displayFlex align-item-center">
      <span class="ml-16 mr-16"> <img src="assets/dateLineSeparator.svg" alt=""> </span>
      <span class="mr-8"> <img src="assets/ic-action-info-24-grey.svg" alt=""></span>
      <span> </span>
     <span class="fs-14 font-weight-400 geoaraea-label">
      Marshal request will be raised if any of bookings being merged have a marshal requirement
     </span>
    </span>
  </div>
</div>

<ng-template [ngIf]="showMarshallToast">
  <div class="cab-snackbar ">
    <span><img src="assets/ic-ui-info-24.svg" alt="error"></span>
    {{toastMsg}}
  </div>
</ng-template>

<div class="stop-list">
  <ng-container *ngFor="let stop of formArray.controls; let stopIndex = index">
    <div class="displayFlex align-item-flex-start">
      <div class="displayFlexColumn cursor-pointer mt-32 mr-16">
        <span (click)="moveStopUp(stopIndex)" [ngClass]="stopIndex==0 ?  'disableDropdown': stopIndex==formArray.controls.length-1 && (airportDrop || busRailwayDrop) ? 'disableDropdown':''"> 
          <img  src="assets/UpToggle.svg" > </span>
        <span (click)="moveStopDown(stopIndex)" [ngClass]="stopIndex==formArray.controls.length-1 ? 'disableDropdown': stopIndex==0 && (airportPickup || busRailwayPickup) ? 'disableDropdown': ''" class="mt-8"
        ><img src="assets/DownToggle.svg"   ></span>
      </div>
      <div class="stop-wrapper displayFlexColumn">
        <app-button *ngIf="stopIndex != formArray.length - 1" class="collapse-button"
          (clickCallback)="toggleRidersView(stopIndex)"
          [prefixIconSrc]="!stopRidersEditActive[stopIndex] ? 'assets/Expand.svg' : 'assets/Collapse.svg'"
          type="icon"></app-button>
        <div class="displayFlexRow">
          <div class="stop-form">
            <div class="field-column address">
              <div class="mb-8 fs-14 font-weight-700 color-181F33 displayFlex">
                <span class="mr-4"><img
                    [src]="getStopLabel(stopIndex)=='Start Address' ? 'assets/start_address.svg' : getStopLabel(stopIndex)=='End Address' ? 'assets/end_address.svg' : 'assets/stop_address.svg' "
                    alt=""></span>
                {{getStopLabel(stopIndex)}}
              </div>
              <app-location-search *ngIf="stop.get('address')" [formControl]="stop.get('address')"
                [getLocationLabel]="getLocationLabel" type="googleAddress" [city]="getCityBoundForStop(stopIndex)"
                [savedLocations]="getSavedLocations(stopIndex)"
                [showSavedLocationOnly]="stopIndex == 0 ? isStartAirportOnly : (stopIndex == formArray.length - 1? isEndAirportOnly : false)"></app-location-search>
            </div>
            <div class="field-column time" *ngIf="stopIndex!=formArray.controls.length-1">
              <div class="mb-10 fs-12 font-weight-400 color-181F33">Pickup Time</div>
              <app-time-picker [formControl]="stop.get('time')" (changeCallback)="timeChangeCallback($event)"></app-time-picker>
            </div>
            <div class="field-column time">
              <div class="mb-20 fs-12 font-weight-400 color-181F33">Date</div>
              <div>{{stop.get('date').value | dateFormatter}}</div>
            </div>
            <div class="field-column" *ngIf="stopIndex != formArray.length - 1">
              <div class="mb-20 fs-12 font-weight-400 color-181F33">Passenger(s)</div>
              <div class="rider-names">
                <div class="rider-list displayFlex" *ngIf="stop.get('riders')?.length; else selectRider">
                  <ng-container *ngFor="let rider of stop.get('riders').controls; let index = index">
                    <span class="rider mr-10 displayFlex" *ngIf="rider.get('name').value">
                      <img *ngIf="rider.get('boardingType').value" class="mr-5"
                        [src]="rider.get('boardingType').value == 'PickUp' ? 'assets/pickupRider.svg' : 'assets/dropRider.svg'" />
                      <span>
                        {{riderMap[rider.get('name').value].name + (index < stop.get('riders').length - 1 ? ' ' : '' )}}
                          </span>
                      </span>
                  </ng-container>
                </div>
                <ng-template #selectRider>
                  <div class="geoaraea-label fs-12 font-weight-700 mt-24"> Expand to add passeneger</div>
                </ng-template>
                <div class="rider-error-msg mt-4"
                  *ngIf="stop.get('riders').errors && stop.get('riders').errors.notEmpty">
                  <img src="assets/error-16.svg" alt="" class="mr-4"> Add passengers to continue
                </div>
              </div>
            </div>
          </div>
          <div class="stop-controls">

            <app-button class="fs-12"
              *ngIf="checkVisibility(removeStopConfig.config) && (stopIndex > 0) && (stopIndex < formArray.length - 1)"
              (clickCallback)="removeStop(stopIndex)" prefixIconSrc="assets/cancelstop.svg" type="removeStop"
              text="Remove Stop"></app-button>
            <div *ngIf="showError(stop)" [title]="formError" class="warning-wrapper">
                <img src="assets/warning-circle.svg" />
              </div>
          </div>
        </div>

        <div class="rider-list-wrapper mt-16"
          *ngIf="stopIndex != formArray.length - 1 && stopRidersEditActive[stopIndex]">
          <table class="traveller-table">
            <thead class="traveller-table-header ">
              <tr>
                <th class="column-heading fs-12 font-weight-700">Passenger</th>
                <th class="column-heading fs-12 font-weight-700">Mobile</th>
                <th class="column-heading boarding-column fs-12 font-weight-700">Boarding type</th>
                <th class="column-heading "></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rider of stop.get('riders').controls; let riderIndex = index;">
                <td class="editable-cells">
                  <app-select [getCustomOptionValue]="getRiderValue" [getCustomOptionLabel]="getRiderLabel"
                    type="dropdown" [formControl]="rider.get('name')" (changeCallback)="onRiderChange(rider, stopIndex)"
                    [hideOptions]="stop.get('riders').getRawValue()" [options]="allRiders">
                  </app-select>
                </td>
                <td class="editable-row-static-content">
                  {{rider.get('mobile').value}}
                </td>
                <td class="editable-cells boarding-column">
                  <app-select class="boarding-dropdown" [getCustomOptionValue]="getBoardingValue"
                    [getCustomOptionLabel]="getBoardingLabel" [getIconFromValue]="getImageFromValue" type="dropdown"
                    [formControl]="rider.get('boardingType')" [hasIcon]="true"
                    (changeCallback)="onRiderChange(rider, stopIndex)" [options]="this.boardingOptions">
                  </app-select>
                </td>
                <td class="text-align-end">
                  <button mat-icon-button (click)="removeRider(riderIndex, stop)">
                    <mat-icon svgIcon="delete"></mat-icon>
                  </button>
                  <!-- <app-button size="tiny" type="primaryText" text="Remove"
                    (clickCallback)="removeRider(riderIndex, stop)"></app-button> -->
                </td>
              </tr>
            </tbody>
          </table>
          <app-button type="primaryText" size="normal" text="Add Passenger"
            (clickCallback)="addRider(stop, stopIndex)"></app-button>
          <div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="checkVisibility(addStopConfig.config) && (stopIndex == formArray.length - 2)">
      <button mis-button type="none" size="sm" class="add-stop" (click)="addStop(stopIndex + 1)">
        <span mis-input-icon class="btn-icon"><img src="/assets/images/add-24.svg" alt="" /></span>
        Add Stop
      </button>
    </div>
  </ng-container>
</div>